import { useContext, useRef } from 'react'
import { CacheContext } from '../providers/CacheProvider'

export const useCache = () => {
  const cacheRef = useRef({
    mounted: false,
    instance: null,
  })
  const cacheManager = useContext(CacheContext)

  if (!cacheRef.current.mounted) {
    cacheRef.current.instance = cacheManager
    cacheRef.current.mounted = true
  }

  return cacheRef.current.instance
}
